module.exports = __webpack_public_path__ + "img/COHR.N.6fb9d758.png";